<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import CompanyInsuranceData from '@/data/company-page-data/turkiye-sigorta/cross-pages/CompanyInsurance'
export default {
  metaInfo: {
    title: 'Türkiye Sigorta İş Yeri Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'Türkiye Sigorta iş yeri sigortası fiyat hesaplaması için teklif alın. Başvuru formunu doldurun en uygun işyeri sigortası fiyatına ulaşın.'
      }
    ]
  },
  name: 'TurkiyeSigortaCompanyInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: CompanyInsuranceData.headerContent,
      crossPageContent: CompanyInsuranceData.crossPageContent,
      faqTitle: CompanyInsuranceData.faqTitle,
      faqTitleDesc: CompanyInsuranceData.faqTitleDesc,
      questions: CompanyInsuranceData.questions,
      getPrice: CompanyInsuranceData.getPrice
    }
  }
}
</script>
